<div class="w-100 h-100">
    <div class="row row-table pt-3">
        <div class="col-md-12">
            <div class="card card_layout">
                <div class="card-header">
                    <div class="form-row justify-content-between align-items-center w-100">
                        <div class="col-auto">
                            <label class="card_header_text">
                                <i class="fas fa-sync-alt reload" @click="reload()"></i>
                                {{$t('userManagementPage.users')}} ({{usersCount}})
                            </label>
                        </div>
                        <div class="col-auto d-flex flex-wrap align-items-center justify-content-end">
                            <button type="button" class="btn btn-primary btn-action mr-2 mb-2" @click="exportUsers">
                                <i class="fas fa-file-export pr-2"></i>{{$t('userManagementPage.export')}}
                            </button>
                            <router-link to="/UserManagement/UserRegistration" tag="button" class="btn btn-primary btn-action mb-2">{{$t('shared.newUser')}} <i class="fas fa-plus px-2"></i></router-link>
                        </div>
                    </div>
                </div>
                <div class="card-body">
                    <div class="form-row align-items-start w-100">
                        <div class="col">
                            <div class="form-row flex-md-nowrap">
                                <div class="col">
                                    <div class="input-group mb-3">
                                        <input class="form-control border-right-0 border-left" v-model="filterModel.username" type="text"
                                            :placeholder="$t('shared.userName')" />
                                        <div class="input-group-append">
                                            <span class="input-group-text right gray"><i class="fas fa-search"></i></span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col">
                                    <div class="input-group mb-3">
                                        <input class="form-control border-right-0 border-left" v-model="filterModel.email" type="text"
                                            :placeholder="$t('shared.userEmail')" />
                                        <div class="input-group-append">
                                            <span class="input-group-text right gray"><i class="fas fa-search"></i></span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col">
                                    <div class="input-group mb-3">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text gray">+966</span>
                                        </div>
                                        <input class="form-control border-right-0 border-left-0" @paste="isNumberFieldPaste($event)"
                                            v-model="filterModel.mobile" :placeholder="$t('shared.phoneNumber')" @keypress="isNumberField($event)"
                                            maxlength="9" type="text" />
                                        <div class="input-group-append">
                                            <span class="input-group-text right gray"><i class="fas fa-search"></i></span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col" v-if="roleFilterOptions.length">
                                    <v-select v-model="filterModel.role" multiple chips deletable-chips dense solo :items="roleFilterOptions" item-text="name"
                                        item-value="id" :label="$t('shared.userRole')" :menu-props="{ maxHeight: 300 }" class="fixed-multi-select" attach
                                        @change="search" />
                                </div>
                                <div class="col" v-if="showProviderNameColumn">
                                    <v-autocomplete v-model="filterModel.providerName"
                                                    :items="providerOptions"
                                                    item-text="name"
                                                    item-value="name"
                                                    :label="$t('userManagementPage.providerName')"
                                                    :no-data-text="$t('shared.noDataAvailable')"
                                                    :menu-props="{ maxHeight: 260, offsetY: true, contentClass: 'user-management-provider-menu' }"
                                                    clearable
                                                    solo
                                                    dense
                                                    attach
                                                    @change="search">
                                    </v-autocomplete>
                                </div>
                            </div>
                        </div>
                        <div class="col-auto mb-3">
                            <button @click="reset" class="btn btn-primary btn-action">{{$t('shared.reset')}}</button>
                        </div>
                    </div>
                    <template>
                        <v-data-table :headers="headers"
                                      :items="users"
                                      :total-items="usersCount"
                                      :rows-per-page-text="$t('shared.rowsPerPage')"
                                      :rows-per-page-items='[10, 25, 50, 100]'
                                      @update:pagination="updatePaginate"
                                      class="elevation-1 table-striped">
                            <template v-slot:items="props">
                                <tr>
                                    <td class="text-center">{{ props.item.username }}</td>
                                    <td class="text-center">{{ props.item.email }}</td>
                                    <td class="text-center" v-if="props.item.mobileNumber !== ''"><span class="pr-1">+966</span> {{ props.item.mobileNumber }}</td>
                                    <td class="text-center" v-if="props.item.mobileNumber === ''">-</td>
                                    <td class="text-center">{{ props.item.roleName }}</td>
                                    <td v-if="showProviderNameColumn" class="text-center">{{ props.item.providerName }}</td>
                                    <td class="text-center">
                                        <v-switch v-model="!props.item.isLocked"
                                                  hide-details
                                                  @click="showLockDialog($event,props.item.id,props.item.isLocked)"></v-switch>
                                    </td>
                                    <td class="text-center">
                                        <div class="d-flex">
                                            <v-tooltip bottom v-if="userRoleName === 'CITC Admin' && props.item.roleName === 'CITC User'">
                                                <template v-slot:activator="{ on }">
                                                    <router-link class="mx-1" :to="`/UserManagement/Permissions/${props.item.id}`" v-on="on">
                                                        <i class="fas fa-user-shield Icon_Edit"></i>
                                                    </router-link>
                                                </template>
                                                <span>Permission</span>
                                            </v-tooltip>
                                            <v-tooltip bottom v-if="props.item.roleName == 'Platform Admin' && (userRole == 9)">
                                                <template v-slot:activator="{ on }">
                                                    <span v-on="on">
                                                        <span class="material-icons Icon_Edit" @click="showSuperUserDialog($event,props.item.id)">
                                                            supervisor_account
                                                        </span>
                                                    </span>
                                                </template>
                                                <span>Make Super Admin</span>
                                            </v-tooltip>

                                            <router-link :to="'/UserManagement/UserInfo/' + props.item.id" tag="a" class="mx-1">
                                                <i class="fas fa-info-circle Icon_Info"></i>
                                            </router-link>
                                            <a class="mx-1" @click="showResendPasswordDialog(props.item.username)">
                                                <i class="fas fa-envelope Icon_Edit"></i>
                                            </a>
                                        </div>
                                    </td>
                                </tr>
                            </template>
                        </v-data-table>
                    </template>
                </div>
            </div>
        </div>
    </div>
    <v-dialog v-model="superUserDialog" persistent width="554">
        <v-card>
            <v-card-title class="headline grey lighten-2" primary-title>
                {{$t('shared.switchAdminToSuper')}}
                <div class="close__dialog">
                    <i class="fas fa-times" @click="hideSuperUserDialog"></i>
                </div>
            </v-card-title>

            <v-card-text class="text-center">
                <p class="mt-3">
                    {{$t('shared.switchAdminToSuperText')}}
                </p>
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>
                <div class="form-row justify-content-end align-items-center">
                    <div class="col-auto mx-3">
                        <a class="link_danger" @click="hideSuperUserDialog">
                            {{$t('shared.no')}}
                        </a>
                    </div>
                    <div class="col-auto">
                        <button class="btn btn-danger px-5 py-2" @click="saveSuperUser">{{$t('shared.yes')}}</button>
                    </div>
                </div>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <v-dialog v-model="lockDialog" persistent width="554">
        <v-card>
            <v-card-title class="headline grey lighten-2" primary-title>
                {{$t('shared.lockInput')}}
                <div class="close__dialog">
                    <i class="fas fa-times" @click="hideLockDialog"></i>
                </div>
            </v-card-title>

            <v-card-text class="text-center">
                <p class="mt-3" v-if="isLocked">
                    {{$t('shared.lockInputText')}}
                </p>
                <p class="mt-3" v-if="!isLocked">
                    {{$t('shared.unlockInputText')}}
                </p>
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>
                <div class="form-row justify-content-end align-items-center">
                    <div class="col-auto mx-3">
                        <a class="link_danger" @click="hideLockDialog">
                            {{$t('shared.no')}}
                        </a>
                    </div>
                    <div class="col-auto">
                        <button class="btn btn-danger px-5 py-2" @click="saveShortCode">{{$t('shared.yes')}}</button>
                    </div>
                </div>
            </v-card-actions>
        </v-card>
    </v-dialog>
    <v-dialog v-model="resendPasswordDialog" persistent width="554">
        <v-card>
            <v-card-title class="headline grey lighten-2" primary-title>
                {{$t('shared.resendPassword')}}
                <div class="close__dialog">
                    <i class="fas fa-times" @click="hideResendPasswordDialog"></i>
                </div>
            </v-card-title>

            <v-card-text class="text-center">
                <p class="mt-3">
                    {{$t('shared.resendPasswordText')}}
                </p>
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>
                <div class="form-row justify-content-end align-items-center">
                    <div class="col-auto mx-3">
                        <a class="link_danger" @click="hideResendPasswordDialog">
                            {{$t('shared.no')}}
                        </a>
                    </div>
                    <div class="col-auto">
                        <button class="btn btn-danger px-5 py-2" @click="resendPasswordEmail">{{$t('shared.yes')}}</button>
                    </div>
                </div>
            </v-card-actions>
        </v-card>
    </v-dialog>
</div>

